import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { ConfirmedValidator } from './ConfirmedValidator';
import { MatDialog,MatDialogRef } from '@angular/material/dialog';
import { TermsconditionsComponent } from './termsconditions/termsconditions.component';
import { ValidationService } from 'src/app/services/validation.service';
import { RegistersuccessComponent } from './registersuccess/registersuccess.component';
import { countries } from 'country-list-json';
import * as isoCountries from 'i18n-iso-countries';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ThemeService } from 'src/app/services/theme.service';
import { ApiService } from 'src/app/services/api.service';
import { QuotationPopupComponent } from './quotation-popup/quotation-popup.component';
import { UtilsService } from 'src/app/services/utils.service';
import { AuthService } from 'src/app/services/auth.service';
import {  TemplateRef } from '@angular/core';
import { AgreeComponent } from '../shared';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?!gmail|yahoo|outlook|hotmail)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.([a-zA-Z]{2,})$/;

interface country {
  value: any;
  viewValue: string;
}

interface PricingSensorItem {
  label: string;
  category: 'MSI' | 'SAR' | 'HSI' | 'SWIR' | 'GHG' | 'TIR' | 'neutral';
}

interface PricingPlanCard {
  planId: number;
  title: string;
  subtitle: string;
  depositLabel: string;
  depositAmount: string;
  depositSupport: string;
  sensorHeading: string;
  sensorSubtext: string;
  sensorCount: string;
  sensorItems: PricingSensorItem[];
  featureHeading: string;
  features: string[];
  recommended?: boolean;
  enterprise?: boolean;
  enterpriseSensorSummary?: string;
  tooltipPlanId?: number;
}
@Component({
  selector: 'app-userregister',
  templateUrl: './userregister.component.html',
  styleUrls: ['./userregister.component.scss']
})
export class UserregisterComponent implements OnInit {
  confirmshowPassword: boolean = true
  showPassword: boolean = true;
  registerForm: any = FormGroup;
  signupform: any = FormGroup;
  submitted = false;
  notRegistered:any;
  warnMsg: any;
  imgUrl = '';
  userPhotoFile: any;
  imageType = false;
  oversize = false;
  validationMessages: any;
  uploaded: boolean = false;
  validPhone = false;
  upload: boolean = false;
  check: boolean = false;
  successMsg: boolean = false;
  dialog: any;
  countries: any;
  isInIframe: boolean;
  organisationTypes: any;
  quotation: boolean = false;
  quotationAmount: number = 0;
  subscription: boolean = false;
  selectedOption: string = 'withDeposit';
  tooltipImagePath: string;
  register: boolean = false;
  selectedPlan: string | null = null;
  expandedPricingPlanIds: number[] = [];
  plans = [
  {
    planId:1,
    accessDetails:[
      {heading:"Access up to five Imaging Sensors"},
      "1 sub-m Multispectral Imaging (MSI)",
      "1 above 1m MSI",
      "1 sub-10m Hyperspectral Imaging (HSI)",
      "2 sub-m Synthetic Aperture Radar (SAR) (X band)"
    ]
  },
  {
    planId:2,
    accessDetails:[
      {heading:"Access up to ten Imaging Sensors"},
      "1 Panchromatic (PAN)",
      "4 MSI (below 1m and above 1m)",
      "3 SAR (X, C bands)",
      "1 HSI",
      "1 Thermal Infrared (TIR)"
    ]
  },
  {
    planId:3,
    accessDetails:[
      {heading:"Full access to all Sensors"},
      "Over 20 imaging and non-imaging sensors, including more MSI, SAR and HSI",
      "MSI starts at 15cm",
      "Stereo and Tri-stereo in several optical resolutions",
      "L-band SAR",
      "InSAR (X, C, and L bands)",
      "Greenhouse Gases (GHG)",
      "Automatic Identification System (AIS) and RF-communication"
    ]
  }
];
  pricingCards: PricingPlanCard[] = [
    {
      planId: 1,
      title: 'Starter',
      subtitle: 'For First-Time Or Occasional Users',
      depositLabel: 'Annual Deposit',
      depositAmount: 'No Minimum',
      depositSupport: 'Pay Now via PayPal or Stripe, Debit Account',
      sensorHeading: 'Imaging sensors',
      sensorSubtext: 'Click to view breakdown',
      sensorCount: '5',
      tooltipPlanId: 1,
      featureHeading: 'Includes',
      sensorItems: [
        { label: '1 sub-m Multispectral Imaging (MSI)', category: 'MSI' },
        { label: '1 above 1m MSI', category: 'MSI' },
        { label: '1 sub-10m Hyperspectral Imaging (HSI)', category: 'HSI' },
        { label: '2 sub-m Synthetic Aperture Radar (SAR) (X band)', category: 'SAR' }
      ],
      features: [
        'Single user, one tasking workflow',
        'Support via platform ‘contact us’',
      ]
    },
    {
      planId: 2,
      title: 'Standard',
      subtitle: 'For Regular Users',
      depositLabel: 'Annual Deposit From',
      depositAmount: 'USD 5,000',
      depositSupport: 'Pay Now, Debit Account',
      sensorHeading: 'Imaging sensors',
      sensorSubtext: 'Click to view breakdown',
      sensorCount: '10',
      tooltipPlanId: 2,
      featureHeading: 'More of everything from users to sensors',
      sensorItems: [
        { label: '1 Panchromatic (PAN)', category: 'MSI' },
        { label: '4 MSI (below 1m and above 1m)', category: 'MSI' },
        { label: '3 SAR (X, C bands)', category: 'SAR' },
        { label: '1 HSI', category: 'HSI' },
        { label: '1 Thermal Infrared (TIR)', category: 'TIR' }
      ],
      features: [
        'Multi-user, multi-tasking workflows',
        'Access to simple feeds',
        'Support via onboarding, platform ‘contact us’ and email'
      ]
    },
    {
      planId: 3,
      title: 'Premium',
      subtitle: 'For High-Volume Users',
      depositLabel: 'Annual Deposit From',
      depositAmount: 'USD 50,000',
      depositSupport: 'Pay Now, Debit Account, or Pay Later by invoice',
      sensorHeading: 'Sensors',
      sensorSubtext: 'Full constellation access',
      sensorCount: '20+',
      tooltipPlanId: 3,
      recommended: true,
      featureHeading: 'Everything in Standard plus',
      sensorItems: [
        { label: 'Over 20 imaging and non-imaging sensors, including more MSI, SAR and HSI', category: 'neutral' },
        { label: 'MSI starts at 15cm', category: 'MSI' },
        { label: 'Stereo and Tri-stereo in several optical resolutions', category: 'MSI' },
        { label: 'L-band SAR', category: 'SAR' },
        { label: 'InSAR (X, C, and L bands)', category: 'SAR' },
        { label: 'Greenhouse Gases (GHG)', category: 'GHG' },
        { label: 'Shortwave Infrared (SWIR)', category: 'SWIR' },
        { label: 'Automatic Identification System (AIS) and RF-communication', category: 'neutral' }
      ],
      features: [
        'Tip-and-Cue and other advanced tasking, permission-based enterprise workflows and user level budgets',
        'Access to advanced feeds',
        'Support via onboarding, platform ‘contact us’, email and monthly check-in',
      ]
    },
    {
      planId: 4,
      title: 'Enterprise',
      subtitle: 'For Related Entities & Organisations',
      depositLabel: 'Annual Deposit From',
      depositAmount: 'USD 100,000',
      depositSupport: 'Pay Now, Debit Account, or Pay Later by invoice',
      sensorHeading: 'Sensors',
      sensorSubtext: 'Full constellation access',
      sensorCount: '20+',
      enterprise: true,
      enterpriseSensorSummary: 'Full Premium sensor suite, tailored to operational requirements.',
      featureHeading: 'Everything in Premium plus',
      sensorItems: [
        { label: 'All Premium sensor access', category: 'neutral' },
        { label: 'Expanded MSI, SAR, HSI and advanced analytics coverage', category: 'MSI' },
        { label: 'Enterprise-scale access for related entities', category: 'neutral' }
      ],
      features: [
        'Hierarchical and multi-account management',
        'Data and information report generation',
        'Activity tracking',
        'Slack + dedicated support channel',
        'Support via onboarding, platform ‘contact us’, email, Slack and monthly check-in'
      ]
    }
  ];

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private userService: UserService,
    private matdialog: MatDialog,
    private vs: ValidationService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private themeService: ThemeService,
    private apiService: ApiService,
    public utilsService: UtilsService,
    private authService: AuthService,
     private dialogRef: MatDialog
    ) {
      this.isInIframe = this.themeService.isInIframe();
      this.tooltipImagePath = '../../../assets/images/union.svg';
     }


  ngOnInit(): void {
    this.selectedPlan = this.authService.getCookie('plan');
    if (this.selectedPlan) {
      this.notRegistered = false
    }
    this.countries = countries;
    this.apiService.getOrganisations().subscribe((res: any) => {
      this.organisationTypes = this.utilsService.sortPurposeOptions(res?.organisationtypes);
    });
    this.registerForm = this.formBuilder.group({
      fullName: ['',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
          this.vs.userNameValidator,
        ],
      ],
      lastName: ['',
      [
        Validators.required,
        Validators.maxLength(50),
        this.vs.userNameValidator,
      ],
     ],
      displayName: ['',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(15),
          this.vs.userNameValidator,
        ],
      ],
      email: ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],

    });
    this.signupform = this.formBuilder.group({
      companyName: [
        '',
        [
          Validators.required
        ],
      ],
      organisationType: [
        '',
        [
          Validators.required
        ],
      ],
      phonenumber: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          // Validators.minLength(10),
          Validators.maxLength(15),
        ],
      ],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern('^(?=.*[A-Z])(?=.*[!@#$%^&_+=]).*$'),
      ],
      ],
      confirm_password: ['', [Validators.required]],
      address1: ['', [Validators.required]],
      address2: [''],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      zip_code: [''],
      photo: [''],
      role: [
        '',
        [
          Validators.required
        ],
      ],
      department: [
        '',
        [
          Validators.required
        ],
      ],
      website: ['', [
        Validators.required,
        Validators.pattern(
          /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/.*)?$/ // URL regex
        )],
      ],
    }, {
      validator: ConfirmedValidator('password', 'confirm_password')

    });
    this.validationMessages = this.vs.account_validation_messages;
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    this.onResetClick(event);
  }

  Space(event: any) {
    if (event.target.selectionStart === 0 && event.code === "Space") {
      event.preventDefault();
    }
  }


  keyPressPhone(event: any) {
    const value = event.target.value;
    if (this.validPhone) {
      this.validPhone = false;
    }
    if (value.length === 15) {
      this.validPhone = true;
      return;
    }
    // const pattern = /[0-9\+\-\ ]/;
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (
      (event.keyCode != 8 && !pattern.test(inputChar)) ||
      value.length > 15 ||
      (inputChar === '0' && value.length === 0)
    ) {
      event.preventDefault();
    }
  }

  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  public toggleconfirmPasswordVisibility(): void {
    this.confirmshowPassword = !this.confirmshowPassword;
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;

  }
  get sign() {
    return this.signupform.controls;

  }
  keyPress(event: any) {
    this.warnMsg = '';
  }

  onSubmit() {
    this.register = false;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    this.submitted = true;
    let result: any;
    const userEmail = encodeURIComponent(this.registerForm.value.email.toLowerCase());
    const pswrd = encodeURIComponent(this.registerForm.value.password || "");

    const loginparams = { userEmail, pswrd };

    this.userService.chkRegisteredUser(loginparams).subscribe(
      (result: any) => {
        // if (result.Msg !== 'User not registered')
        if (result) {
          if (result.Msg === 'User not registered') {
            this.warnMsg = '';
            this.notRegistered = true;
            // let docs = document.getElementById('button')
            // if (docs) {
            //   docs.click();
            // }
          }
          if (result.Msg === 'Wrong password') {
            this.notRegistered = false;
            this.warnMsg = 'User already registered with this email';

            return
          }
        }
      },
      (err) => {
        return false;
      }
    );
  }




  submitSignup() {
    this.register = true;
    this.submitted = true;
    // stop here if form is invalid
    if (this.signupform.invalid) {
      return;
    }
    //True if all the fields are filled
    if (this.submitted) {
      let userName = this.registerForm.value.fullName;
      let lastName = this.registerForm.value.lastName;
      userName = userName.replace(/\w\S*/g, function (txt: any) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      lastName = lastName.replace(/\w\S*/g, function (txt: any) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      //(this.registerForm.value.displayName, this.signupform.value.companyName, this.registerForm.value, this.signupform.value, this.imgUrl)
      const displayName = this.registerForm.value.displayName;
      const company = this.signupform.value.companyName;
      const organisationType = this.signupform.value.organisationType;
      const email = this.registerForm.value.email.toLowerCase();
      const phone = this.signupform.value.phonenumber;
      const pswrd = this.signupform.value.password.trim();
      const re_pswrd = this.signupform.value.confirm_password.trim();
      const address1 = this.signupform.value.address1;
      const address2 = this.signupform.value.address2;
      const city = this.signupform.value.city;
      const country = this.signupform.value.country.name;
      isoCountries.registerLocale(require("i18n-iso-countries/langs/en.json"));
      const twoLetterCode = this.signupform.value.country.code;
      const threeLetterCode = isoCountries.alpha2ToAlpha3(twoLetterCode);
      const zip_code = this.signupform.value.zip_code;
      let quotationAmount = 0;
      if (this.quotation) {
        quotationAmount = +this.quotationAmount;
      }
      const role = this.signupform.value.role;
      const website = this.signupform.value.website;
      const department = this.signupform.value.department
      const userplan = Number(this.selectedPlan);

      this.recaptchaV3Service.execute('importantAction').subscribe((token: string) => {
        const reCAPTCHAToken = token;
        let userData = {
          name: userName,
          displayname: displayName,
          company: company,
          phone: phone,
          email: email,
          password: pswrd,
          photoFile: this.userPhotoFile,
          address1: address1,
          address2: address2,
          city: city,
          country: country,
          countryCode: threeLetterCode,
          zip_code: zip_code,
          lastName: lastName,
          organisationType: organisationType,
          reCAPTCHAToken: reCAPTCHAToken,
          quotation: this.quotation,
          quotationAmount: quotationAmount,
          role: role,
          website: website,
          department: department,
          user_plan: userplan
         }

        this.userService.addUser(userData).subscribe((res: any) => {
          if (res.Msg != 'Failed captcha verification') {
            const dialogRef = this.matdialog.open(RegistersuccessComponent, {
              width: '60%', backdropClass: 'blurred', disableClose: true,
              data: { user: '', type: 'registration' }
            });
          }
          if (res.Msg.includes('Successfully registered')) {
            if (email) {
              const mailObj = {
                id: email,
                sub: 'Thank you',
                content: 'Thank you for registering with www.risingsunmart.com'
              }
            }
            this.warnMsg = res.Msg;
            this.successMsg = true;
            this.authService.deleteCookie('plan');
          }
        });
      });

    }

  }
  acceptTerms() {
    this.check = !this.check
  }
  clearImages() {
    this.imgUrl = '';
  }
  onFileSelected(event: any) {
    // this.userPhotoFile = this.sanitize.bypassSecurityTrustResourceUrl( event.target.files[0]);
    const allowedExtensions = /(\.jpg|\.jpeg)$/i;
    this.userPhotoFile = event.target.files[0];
    let docs = document.getElementById('term')
    if (docs) {
      docs.click();
    }
    if (!allowedExtensions.exec(this.userPhotoFile.name)) {
      this.imageType = true;
      this.imgUrl = '';
    } else {
      this.imageType = false;
      if (this.userPhotoFile.size < 20480) {
        /* less than 20kb */
        this.oversize = false;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.imgUrl = e.target.result;
          this.uploaded = true
          this.upload = true
        };
        reader.readAsDataURL(this.userPhotoFile);
      } else {
        this.oversize = true;
        this.imgUrl = '';
      }
    }
  }
  OpenPopup(event?) {

    event?.preventDefault();
    const dialogRef = this.matdialog.open(AgreeComponent, {
          width: '65%',
          maxHeight: '90vh',
          backdropClass: 'blurred',
          disableClose: true,
      data: {type: 'terms'}
     });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.click === 1) {
        this.check = true;
      }
      else {
      this.check = false;
      }
    });
    backdropClass: 'backdropBackground' // This is the "wanted" line
  }

  requestQuotation() {
    this.quotationAmount = 0;
    let userEmail = this.registerForm.value.email.toLowerCase();

      const dialogRef = this.matdialog.open(QuotationPopupComponent,
      {
        data: { user: userEmail,message: 'register'},
        backdropClass: 'blurred',
        disableClose: true,
        width: '60%',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.type === 1) {
          this.quotation = true;
          this.quotationAmount = result.quotationAmount;
        }
        else
          this.quotation = false;
      });
  }

  acceptSubscription(option) {
    this.selectedOption = option;
    if (this.selectedOption === 'withDeposit') this.subscription = false;
    else if (this.selectedOption === 'withoutDeposit') this.subscription = true;

    if (this.subscription) this.quotation = false;
    else if (!this.subscription && this.quotationAmount > 0) this.quotation = true;
  }

  onFocusProject(controlName: string) {
    this.registerForm.get(controlName).markAsTouched();
  }

  onFocusForm(controlName: string) {
    this.signupform.get(controlName).markAsTouched();
  }
  planClick(value:number){
    this.authService.setCookie('plan', value.toString(), 30);
     this.selectedPlan = value.toString()
     this.authService.emitPlan(value.toString());
    this.notRegistered = false;
  }
  onResetClick(event: Event){
    event.preventDefault();
    this.authService.deleteCookie('plan');
     this.selectedPlan = null;
     this.notRegistered = null;
     this.authService.emitPlan(null);
     this.registerForm = this.formBuilder.group({
      fullName: ['',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
          this.vs.userNameValidator,
        ],
      ],
      lastName: ['',
      [
        Validators.required,
        Validators.maxLength(50),
        this.vs.userNameValidator,
      ],
     ],
      displayName: ['',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(15),
          this.vs.userNameValidator,
        ],
      ],
      email: ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],

    });
    this.signupform = this.formBuilder.group({
      companyName: [
        '',
        [
          Validators.required
        ],
      ],
      organisationType: [
        '',
        [
          Validators.required
        ],
      ],
      phonenumber: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          // Validators.minLength(10),
          Validators.maxLength(15),
        ],
      ],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern('^(?=.*[A-Z])(?=.*[!@#$%^&_+=]).*$'),
      ],
      ],
      confirm_password: ['', [Validators.required]],
      address1: ['', [Validators.required]],
      address2: [''],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      zip_code: [''],
      photo: [''],
      role: [
        '',
        [
          Validators.required
        ],
      ],
      department: [
        '',
        [
          Validators.required
        ],
      ],
      website: ['', [
        Validators.required,
        Validators.pattern(
          /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/.*)?$/ // URL regex
        )],
      ],
    }, {
      validator: ConfirmedValidator('password', 'confirm_password')
    });
     this.register = false;
    this.submitted = false;
    this.quotation = false;
    this.check = false;
    this.uploaded = false;
    this.oversize = false;
    this.imageType = false;
    this.userPhotoFile;
    this.imgUrl = '';
  }
  togglePricingAccordion(planId: number) {
    this.expandedPricingPlanIds = this.isPricingAccordionOpen(planId)
      ? this.expandedPricingPlanIds.filter((id) => id !== planId)
      : [...this.expandedPricingPlanIds, planId];
  }

  isPricingAccordionOpen(planId: number): boolean {
    return this.expandedPricingPlanIds.includes(planId);
  }

  openTooltip(template: TemplateRef<any>,plan) {
  const selectedPlan = this.plans.find(p => p.planId === plan);

  const accessDetails = selectedPlan?.accessDetails || [];
   console.log("accessDetails",accessDetails)
    this.dialogRef.open(template, {
    panelClass: 'black-dialog-bg',
    data: {
      accessDetails: accessDetails,
      product: 'planUpgrade'
    }
  });
}
}
